import { Link } from 'react-router-dom';
import Card from '../../../../../components/global/Card';
import styles from '../../../../../styles/CardWidget.module.css';

export default function CardWidget({ items }) {
  return (
    <div className={styles.root} aria-label="KPI summary cards">
      <div className={styles.list}>
        {items.map((item) => {
          const card = (
            <Card
              title={item.title}
              value={item.value}
              topRight={item.topRight}
              bottomText={item.bottomText}
              graphData={item.graphData}
              graphAriaLabel={item.graphAriaLabel}
            />
          );

          if (!item.to) {
            return (
              <div key={item.id} className={styles.item}>
                {card}
              </div>
            );
          }

          return (
            <Link
              key={item.id}
              to={item.to}
              className={`${styles.item} ${styles.itemLink}`}
              aria-label={`View ${item.title}`}
            >
              {card}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
